<template>
  <Layout>
    <div class="wrap-box">
      <div class="content-box fs-14">
        <img src="@/assets/images/black-tea.svg" alt="" >
        <p>数据集成操作需要登录入路通系统进行。</p>
        <button class="btn btn-primary" type="button" @click="loginRuluka">
        跳转登录
        </button>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import appConfig from "../../../app.config";
import { RUL_API_SVC_HOST } from '@/config/common';

export default {
  page: {
    title: "数据集成",
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  data() {
    return {
      
    
    };
  },
  components: {
    Layout,
  },
  methods:{
    loginRuluka(){
      window.open(RUL_API_SVC_HOST, '_blank')
    }
  }
 
 
};
</script>
<style lang="scss" scoped>
.wrap-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-35%);
  .content-box{
    width: 450px;
    height: 280px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    padding-bottom: 30px;
    img{
      width: 155px;
    }
    button{
      width: 100%;
    }
  }
}

</style>


